<template>
  <TabBar gap="gap-0">
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsAgencyRouteTabs.Details"
      :to="{ name: ReviewsRouteName.ReviewsAgencyViewDetails }"
      data-testid="agency-tab-details"
    >
      {{ t('Reviews.agency.view.tab.details') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsAgencyRouteTabs.IndustriesAndServices"
      :to="{ name: ReviewsRouteName.ReviewsAgencyViewIndustriesAndServices }"
      data-testid="agency-tab-industries"
    >
      {{ t('Reviews.agency.view.tab.industriesAndServices') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsAgencyRouteTabs.Traits"
      :to="{ name: ReviewsRouteName.ReviewsAgencyViewTraits }"
      data-testid="agency-tab-traits"
    >
      {{ t('Reviews.agency.view.tab.traits') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsAgencyRouteTabs.Partners"
      :to="{ name: ReviewsRouteName.ReviewsAgencyViewPartners }"
      data-testid="agency-tab-partners"
    >
      {{ t('Reviews.agency.view.tab.partners') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsAgencyRouteTabs.Assets"
      :to="{ name: ReviewsRouteName.ReviewsAgencyViewAssets }"
      data-testid="agency-tab-assets"
    >
      {{ t('Reviews.agency.view.tab.assets') }}
    </NavTabBarItem>
  </TabBar>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { ReviewsRouteName, ReviewsAgencyRouteTabs } from '@/router/types'
import { TabBar, NavTabBarItem } from '@/ui/Tabs'

const { t } = useI18n()
const route = useRoute()

const disabled = computed(() => {
  return route.name?.toString().startsWith(ReviewsRouteName.ReviewsAgencyEdit)
})
</script>
